import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function sessionId() {
  let s = localStorage.getItem("tnsq_sid");
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("tnsq_sid", s); }
  return s;
}

// First-party analytics: real pageviews + time-on-page. No third parties.
export const Analytics = () => {
  const { pathname } = useLocation();
  const enter = useRef(Date.now());
  const prevPath = useRef(pathname);

  const sendDuration = () => {
    const secs = Math.round((Date.now() - enter.current) / 1000);
    if (secs < 1 || secs > 3600) return;
    const body = JSON.stringify({ session_id: sessionId(), path: prevPath.current, event: "duration", duration: secs });
    try {
      navigator.sendBeacon(`${API}/track`, new Blob([body], { type: "application/json" }));
    } catch (e) { /* noop */ }
  };

  useEffect(() => {
    // duration for previous page, then new pageview
    if (prevPath.current !== pathname) { sendDuration(); enter.current = Date.now(); prevPath.current = pathname; }
    axios.post(`${API}/track`, { session_id: sessionId(), path: pathname, event: "pageview", ref: document.referrer || "" }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    const onHide = () => { if (document.visibilityState === "hidden") sendDuration(); };
    document.addEventListener("visibilitychange", onHide);
    window.addEventListener("beforeunload", sendDuration);
    return () => {
      document.removeEventListener("visibilitychange", onHide);
      window.removeEventListener("beforeunload", sendDuration);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
